import request from '@/utils/request'
const qs = require('qs')

// 获取关键字匹配
export function getMatchKeywords (data) {
  return request({
    url: '/ooh-search/v1/search/getmatchkeywords',
    method: 'post',
    data: qs.stringify(data)
  })
}
// PDF预览
export function getOrderPDFList (data) {
  return request({
    url: '/ooh-search/v1/pdf/getorderpdflist',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取订单城市统计
export function getCityStatistic (data) {
  return request({
    url: '/ooh-search/v1/orderstatistic/getcitystatistic',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取指标统计
export function getIndexStatistic (data) {
  return request({
    url: '/ooh-search/v1/orderstatistic/getindexstatistic',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 新增站点
export function addStation (data) {
  return request({
    url: '/ooh-search/v1/purchase/addstation',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 清空购物车/订单
export function clearOrder (data) {
  return request({
    url: '/ooh-search/v1/purchase/clearorder',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 删除站点
export function deleteStation (data) {
  return request({
    url: '/ooh-search/v1/purchase/deletestation',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 预创建订单,返回订单主键
export function getPreOrderId (data) {
  return request({
    url: '/ooh-search/v1/order/getpreorderid',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取当前用户所在城市
export function getCurrentCity () {
  return request({
    url: '/ooh-search/v1/search/getcurrentcity',
    method: 'get'
  })
}
// 获取商家详情
export function listBusinessDetails (data) {
  return request({
    url: '/ooh-search/v1/search/listBusinessDetails',
    timeout: 200000,
    method: 'get',
    params: data
  })
}
// 获取推荐站点
export function getRecommendStations (data) {
  return request({
    url: '/ooh-search/v1/search/getrecommendstations',
    timeout: 200000,
    method: 'get',
    params: data
  })
}
